export const BG_PRESETS = [
  { key: "highway-dusk", label: "Highway at dusk", kind: "scene", dim: 0.15 },
  { key: "open-road-day", label: "Open road", kind: "scene", dim: 0.1 },
  { key: "night-highway", label: "Night highway", kind: "scene", dim: 0 },
  { key: "fleet-yard-sunrise", label: "Fleet yard sunrise", kind: "scene", dim: 0.15 },
  { key: "lane-markings", label: "Lane markings", kind: "pattern", dim: 0 },
  { key: "route-map", label: "Route map", kind: "pattern", dim: 0 },
  { key: "topo", label: "Topographic", kind: "pattern", dim: 0 },
  { key: "asphalt", label: "Asphalt", kind: "pattern", dim: 0 },
];

export const presetUrl = (key) => `${process.env.PUBLIC_URL || ""}/chat-bg/${key}.svg`;
